exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item[data-v-3400d44a] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -webkit-align-items: start;\n      -ms-flex-align: start;\n          align-items: start;\n  margin-bottom: 12px;\n  font-size: 13px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 10px;\n}\n", ""]);

// exports
